import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './shared/components/login/sign-in/sign-in.component';
import { LoginLayoutComponent } from './layouts';
import { HomeComponent } from './entities/home/home.component';
import { GuiLayoutComponent } from './layouts/gui-layout/gui-layout.component';
import { ForgotComponent } from './shared/components/login/forgot/forgot.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { EnergyComponent } from './entities/energy/energy.component';
import { DevicesComponent } from './entities/devices/devices.component';
import { SchedulingComponent } from './entities/scheduling/scheduling.component';
import { RoutinesComponent } from './entities/routines/routines.component';
import { NewPasswordComponent } from './shared/components/login/new-password/new-password.component';
import { DeviceDetailComponent } from './entities/devices/device-detail/device-detail.component';
import { BoxOfflineComponent } from './shared/components/box-offline/box-offline.component';
import { AlertsComponent } from './entities/alerts/alerts.component';
import { IsAliveComponent } from './shared/components/is-alive/is-alive.component';
import { ProfileComponent } from './entities/profile/profile.component';
import { MessagesComponent } from './entities/messages/messages.component';
import { ContactsComponent } from './shared/components/contacts/contacts.component';
import { FaqComponent } from './shared/components/faq/faq.component';
import { TutorialComponent } from './shared/components/tutorial/tutorial.component';
import { environment } from '../environments/environment';
import { FirstLoginComponent } from './shared/components/login/first-login/first-login.component';
import { NoSmartMeterComponent } from './shared/components/no-smart-meter/no-smart-meter.component';
import { NoHouseUserComponent } from './shared/components/no-house-user/no-house-user.component';
import { EfficiencyComponent } from './entities/efficiency/efficiency.component';
import { OnboardingComponent } from './shared/components/coachmarks/onboarding/onboarding.component';

const appRoutes: Routes = [
  {
    path: 'EdpPortal/Login',
    redirectTo: 'new-password',
    pathMatch: 'full'
  },
  {
    path: 'edpportal/Login',
    redirectTo: 'new-password',
    pathMatch: 'full'
  },
  {
    path: 'EdpPortal',
    redirectTo: '',
  },
  {
    path: 'edpportal',
    redirectTo: '',
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    component: OnboardingComponent
  },
  {
    path: '',
    component: GuiLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'energy',
        component: EnergyComponent,
      },
      {
        path: 'energy/no-smart-meter',
        component: NoSmartMeterComponent,
      },
      {
        path: 'box-offline',
        component: BoxOfflineComponent
      },
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'tutorials',
        component: TutorialComponent
      },
      {
        path: 'contacts',
        component: ContactsComponent
      },
      {
        path: 'devices',
        children: [
          {
            path: '',
            component: DevicesComponent
          },
          {
            path: ':moduleId',
            component: DeviceDetailComponent
          },
        ]
      },
      {
        path: 'scheduling',
        component: SchedulingComponent
      },
      {
        path: 'routines',
        component: RoutinesComponent
      },
      {
        path: 'alerts',
        component: AlertsComponent
      },
      {
        path: 'efficiency',
        component: EfficiencyComponent
      },
      {
        path: 'messages',
        component: MessagesComponent
      },
      {
        path: 'no-house-user',
        component: NoHouseUserComponent
      },
    ]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'sign-in',
        component: SignInComponent
      },
      {
        path: 'forgot',
        component: ForgotComponent
      },
      {
        path: 'new-password',
        component: NewPasswordComponent
      },
      {
        path: 'confirmaccount',
        component: FirstLoginComponent
      },
      {
        path: 'is-alive',
        component: IsAliveComponent
      }
    ]
  },
  { path: '**', canActivate: [AuthGuard], component: PageNotFoundComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: environment.useHash })],
  // By re-exporting the RouterModule here and importing
  // AppRoutingModule in AppModule, the components declared in
  // AppModule will have access to router directives such as
  // RouterLink and RouterOutlet.
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts